module.exports = __webpack_public_path__ + "img/012.6f6a5589.png";